import { h } from '@debbie/cortex/dist/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import { useUpdateTypesMap } from '@debbie/cortex/dist/update-types/index.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Checkbox } from '../../index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const WorkflowsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const workflowsLoadable = useWorkflows();
    const workflows = h.hasData(workflowsLoadable) ? workflowsLoadable.data : null;
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : null;
    const inWorkflowIds = caseFilter.inWorkflowIds;
    const selectedWorkflows = inWorkflowIds
        ? workflows?.filter((workflow) => inWorkflowIds.includes(workflow.workflowId))
        : workflows;
    const tasks = selectedWorkflows
        ?.reduce((acc, workflow) => {
        for (let i = 0; i < workflow.tasks.length; i++) {
            const task = workflow.tasks[i];
            const updateType = updateTypesMap && updateTypesMap[task.updateTypeId];
            if (updateType) {
                acc = acc.concat({
                    task,
                    updateType,
                    position: task.position,
                });
            }
        }
        return acc;
    }, [])
        .sort((a, b) => a.position.y - b.position.y);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.workflowsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.inWorkflowIds && caseFilter.inWorkflowIds.length), header: lang.caseFilter.isInWorkflows, onDeactivate: () => caseFilterStore.clearFilter('inWorkflowIds') },
            React.createElement(Select, { value: (caseFilter.inWorkflowIds || []).map((workflowId) => {
                    const workflow = workflows &&
                        workflows.find((workflow) => workflow.workflowId === workflowId);
                    return {
                        label: workflow?.title || workflowId,
                        value: workflowId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectWorkflows, classNamePrefix: "select", options: (workflows || []).map((workflow) => ({
                    label: workflow.title,
                    value: workflow.workflowId,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        inWorkflowIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.nextTaskIds && caseFilter.nextTaskIds.length), header: lang.caseFilter.nextTaskIds, onDeactivate: () => caseFilterStore.clearFilter('nextTaskIds') },
            React.createElement(Select, { value: (caseFilter.nextTaskIds || []).map((taskId) => {
                    const task = tasks && tasks.find(({ task }) => task.id === taskId);
                    return {
                        label: 
                        // @ts-ignore
                        lang.updateTypes[task?.task.updateTypeId] ||
                            task?.updateType?.label ||
                            taskId,
                        value: taskId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectNextTaskIds, classNamePrefix: "select", options: (tasks || []).map((task) => ({
                    label: lang.updateTypes[task?.task.updateTypeId] ||
                        task?.updateType?.label ||
                        task.task.id,
                    value: task.task.id,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        nextTaskIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.currentTaskIds && caseFilter.currentTaskIds.length), header: lang.caseFilter.currentTaskIds, onDeactivate: () => caseFilterStore.clearFilter('currentTaskIds') },
            React.createElement(Select, { value: (caseFilter.currentTaskIds || []).map((taskId) => {
                    const task = tasks && tasks.find(({ task }) => task.id === taskId);
                    return {
                        label: 
                        // @ts-ignore
                        lang.updateTypes[task?.task.updateTypeId] ||
                            task?.updateType?.label ||
                            taskId,
                        value: taskId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCurrentTaskIds, classNamePrefix: "select", options: (tasks || []).map((task) => ({
                    label: lang.updateTypes[task?.task.updateTypeId] ||
                        task?.updateType?.label ||
                        task.task.id,
                    value: task.task.id,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        currentTaskIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.noNextTask === 'boolean', header: lang.caseFilter.noNextTask, onDeactivate: () => caseFilterStore.clearFilter('noNextTask') },
            React.createElement(Checkbox, { onChange: (e) => {
                    caseFilterStore.updateFilter({
                        noNextTask: e.target.checked,
                    });
                }, placeholder: lang.caseFilter.noNextTask, checked: !!caseFilter.noNextTask }))));
};
export default WorkflowsGroup;
//# sourceMappingURL=WorkflowsGroup.js.map